module.exports = __webpack_public_path__ + "img/HoveredTelegramIcon.0415626b.svg";